// eslint-disable-next-line import/prefer-default-export
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SCENES: {
    ROOT: '/scenes',
    NEW: '/create/new',
    EDIT: (id = ':id') => `/${id}`,
  },
  STUDIO: {
    ROOT: '/studios',
    NEW: '/create/new',
    EDIT: (id = ':id') => `/${id}`,
  },
  AI_PRODUCT: {
    ROOT: '/ai-product',
    NEW: '/create/new',
    EDIT: (id = ':id') => `/${id}`,
    SILO: (id = ':id') => `/${id}/silo`,
    BACKGROUND: (id = ':id') => `/${id}/background`,
    VIDEO: (id = ':id') => `/${id}/video-beta`, //video
    TEXT: (id = ':id') => `/${id}/text`,
    CAPTION: (id = ':id') => `/${id}/caption`,
    DOWNLOAD: (id = ':id') => `/${id}/download`,
  },
  SILO: {
    ROOT: '/silo',
    NEW: '/create/new',
    EDIT: (id = ':id') => `/${id}`,
  },
  LIFESTYLE: {
    ROOT: '/lifestyle',
    NEW: '/create/new',
    EDIT: (id = ':id') => `/${id}`,
  },
  VIDEO: {
    ROOT: '/video',
    NEW: '/create/new',
    EDIT: (id = ':id') => `/${id}`,
  },
  DESCRIPTION: {
    ROOT: '/description',
    NEW: '/create/new',
    EDIT: (id = ':id') => `/${id}`,
  },
};
